import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { RosterTeamMemberScreen } from '@/features/hr-reports/roster-team-member-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/roster-team-member')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RosterTeamMemberScreenRoute,
})

function RosterTeamMemberScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <RosterTeamMemberScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/hr/reports/roster-team-member', search: next })
      }
    />
  )
}
